// extracted by mini-css-extract-plugin
export default {"container":"dE-z","dimension":"eE-z","dimensionLabels":"fE-z"};